import { render, staticRenderFns } from "./ContratoTratamientoDatos.vue?vue&type=template&id=9e432ef8&"
import script from "./ContratoTratamientoDatos.vue?vue&type=script&lang=js&"
export * from "./ContratoTratamientoDatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports